import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Delivery extends Component {
  constructor() {
    super();
    this.state = {
      error_orders: [],
      successful_orders: [],
      files_status: false
    }

    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
  }

  getDelivery(){
    const delivery_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/delivery/${delivery_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(json_res => {
            this.setState({
              first_orders: json_res.successful_orders,
              successful_orders: json_res.successful_orders,
              error_orders: json_res.error_orders,
              files_status: json_res.status
            })
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  handleEmailChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.first_orders.filter(order =>
        order.user__email.toLowerCase().startsWith(value));
      this.setState({successful_orders: searchResult})
    } else {
      this.setState(prevState => ({successful_orders: prevState.first_orders}))
    }
  }

  handleNameChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.first_orders.filter(order => {
        if (order.user__first_name && order.user__first_name) {
          if (order.user__first_name.toLowerCase().startsWith(value)){
            return order
          } else if (order.user__last_name.toLowerCase().startsWith(value)){
            return order
          }
        }
      })
      if (searchResult[0] !== undefined) {
        this.setState({successful_orders: searchResult})
      } else {
        this.setState({successful_orders: []})
      }
    } else {
      this.setState(prevState => ({successful_orders: prevState.first_orders}))
    }
  }

  componentDidMount() {
    this.getDelivery()
  }

  render() {
    return(
      <div className="Delivery">
        <h1>Delivery - {this.props.match.params.id}</h1>
        <div className="Products-body">
          {
            this.state.files_status
            ?
            <p className="Files-success">Deliveryn & filerna är skapade!</p>
            :
            <p className="Files-process">Deliveryn håller på att skapas (kan ta upp mot 30 min)</p>
          }
          <h2>Error Orders</h2>
            <table>
              <thead>
                <tr>
                  <th>Kund Email</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.error_orders.map(order => {
                    return(
                      <tr key={order.fake_id}>
                        <td>{order.user__email}</td>
                        <td>{order.error}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            <h2>Successful Orders</h2>
              <table>
                <thead>
                  <tr>
                    <th>Kund Email</th>
                    <th>Kund Namn</th>
                    <th>Order nr</th>
                    <th>Klarna nr</th>
                    <th>Redigera</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-r-20">
                      <input
                        type="text"
                        className="table-input"
                        placeholder="Email"
                        onChange={this.handleEmailChange} />
                    </td>
                    <td className="p-r-20">
                      <input
                        type="text"
                        className="table-input"
                        placeholder="Name"
                        onChange={this.handleNameChange}/>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                  </tr>
                  {
                    this.state.successful_orders.map(order => {
                      return(
                        <tr key={order.fake_id}>
                          <td>{order.user__email}</td>
                          <td>{order.user__first_name} {order.user__last_name}</td>
                          <td>{order.fake_id}</td>
                          <td>{order.klarna_id}</td>
                          <td>
                            <Link
                              to={`/backoffice/order/${order.fake_id}`}
                              className="table-button">
                              Granska
                            </Link>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
        </div>
      </div>
    )
  }
}

export default Delivery



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Delivery.jsx